/**
 * j file collection <id>
 * Show collection detail with all file links
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../services/config.service.js';
import { FileService } from '../../services/file.service.js';

function formatSize(bytes: number): string {
    if (bytes < 1024) return `${bytes}B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
}

function getTypeLabel(contentType: string): string {
    const map: Record<string, string> = {
        'text/html': 'HTML', 'text/markdown': 'MD', 'text/css': 'CSS',
        'application/javascript': 'JS', 'application/json': 'JSON',
        'image/png': 'PNG', 'image/jpeg': 'JPG', 'image/gif': 'GIF',
        'image/svg+xml': 'SVG', 'image/webp': 'WEBP',
    };
    return map[contentType] || contentType.split('/').pop()?.toUpperCase() || '?';
}

export function createFileCollectionShowCommand(): Command {
    return new Command('collection')
        .description('Show collection detail with all file links')
        .argument('<id>', 'Collection ID')
        .option('--open', 'Open index URL in browser')
        .option('-j, --json', 'JSON output')
        .action(async (idArg: string, opts) => {
            try {
                const configService = new ConfigService();
                const config = await configService.load();
                if (!config) {
                    console.error(chalk.red('Chưa đăng nhập. Chạy "j auth" trước.'));
                    process.exit(1);
                }

                const id = parseInt(idArg);
                if (isNaN(id)) {
                    console.error(chalk.red('ID phải là số'));
                    process.exit(1);
                }

                const service = new FileService();
                const result = await service.getCollection(config, id);

                if (opts.json) {
                    console.log(JSON.stringify(result, null, 2));
                    return;
                }

                console.log();
                console.log(chalk.bold.cyan(`  ${result.name}`) + chalk.dim(` (#${result.id})`));
                console.log(chalk.dim(`  Scope: ${result.scope}${result.projectId ? ` | Project: ${result.projectId}` : ''}`));
                console.log(chalk.dim(`  ${result.fileCount} files | ${formatSize(result.totalSize)}`));
                if (result.indexUrl) {
                    console.log(chalk.cyan(`  Index: `) + result.indexUrl);
                }
                console.log();

                if (result.files.length === 0) {
                    console.log(chalk.dim('  Chưa có file nào.'));
                } else {
                    for (const file of result.files) {
                        const size = formatSize(file.contentSize);
                        const type = getTypeLabel(file.contentType);
                        const path = file.filePath || file.filename;
                        console.log(
                            `  ${chalk.dim(`[${type}]`)} ${path} ${chalk.dim(`(${size})`)}`
                        );
                        console.log(`    ${chalk.dim(file.url)}`);
                    }
                }

                console.log();

                // Auto-open
                if (opts.open && result.indexUrl) {
                    const { exec } = await import('child_process');
                    const openCmd = process.platform === 'darwin' ? 'open' : process.platform === 'win32' ? 'start' : 'xdg-open';
                    exec(`${openCmd} "${result.indexUrl}"`);
                }

            } catch (error) {
                console.error(chalk.red(`Lỗi: ${error instanceof Error ? error.message : String(error)}`));
                process.exit(1);
            }
        });
}
